<form [formGroup]="searchForm" class="search-form" *ngIf="isVisible()">
  <app-input *ngIf="showSearch"
             type="text"
             class="search-input"
             [formControl]="searchForm.controls.search"
             [isSearch]="true"
             [label]="'general.actions.search' | translate"
             (inputChange)="onFilterTextChange($event)">
  </app-input>
</form>

<div class="card-list">
  <ng-template *ngTemplateOutlet="addButton"></ng-template>
  <ng-container *ngFor="let item of data">
    <ng-template *ngTemplateOutlet="cardItem, context: { $implicit: item }"></ng-template>
  </ng-container>
  <ng-template *ngTemplateOutlet="cardItemLoading, context: { $implicit: nextItemsLoading }"></ng-template>
</div>
